import { API_DEV } from "constants/api";
import { updateUserForAbilities } from "constants/abilities";
import { DOCUMENT_TYPE_PHOTO } from "constants/dbValues";

import { header, handleAPIResult, serialize, formatMaterialFilters, log } from "../utils";

export const userService = {
  login,
  logout,
  update,
  list,
  get,
  create,
  update,
  powerBiUrl,
  quickLoginUsers,
  quickLogin,
};

function login(email, password) {
  const postInfo = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },

    body: JSON.stringify({
      user: {
        email: email,
        password: password,
      },
    }),
  };

  return new Promise((resolve, reject) => {
    var token = "";

    fetch(API_DEV + "/login", postInfo)
      .then((result) => {
        const error = result.status !== 200;

        if (!error) {
          token = result.headers.get("Authorization");

          result
            .json()
            .then((r) => {
              var user = {
                ...r,
                token,
              };

              localStorage.setItem("user", JSON.stringify(user));
              updateUserForAbilities(user);
              resolve(user);
            })
            .catch((e) => {
              reject(e);
            });
        } else {
          result
            .json()
            .then((r) => {
              if (r.error && r.error === "disabled") reject("Disabled");
              else reject("Unauthorized");
            })
            .catch((e) => {
              reject(e);
            });
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function logout() {
  localStorage.removeItem("user");
  localStorage.removeItem("view_mode");
  return {};
}

// Dev-only: lists every user (the API 404s outside development) for the
// quick-login page.
function quickLoginUsers() {
  const getInfo = {
    method: "GET",
    headers: { Accept: "application/json" },
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/quick_login/users", getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => resolve(result))
      .catch((error) => reject(error));
  });
}

// Dev-only: logs in as the given user without a password (the API 404s
// outside development).
function quickLogin(userId) {
  const postInfo = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/quick_login/" + userId, postInfo)
      .then((result) => {
        if (result.status !== 200) {
          reject("Unauthorized");
          return;
        }

        const token = result.headers.get("Authorization");
        result
          .json()
          .then((r) => {
            var user = { ...r, token };
            localStorage.setItem("user", JSON.stringify(user));
            updateUserForAbilities(user);
            resolve(user);
          })
          .catch((e) => reject(e));
      })
      .catch((error) => reject(error));
  });
}

function list(filters = {}, material = {}) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  var qs =
    Object.keys(material).length === 0
      ? serialize(filters)
      : formatMaterialFilters(filters, material);
  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/users?" + qs, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function get(id) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/users/" + id, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function create(user) {
  const postInfo = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...header(),
    },

    body: JSON.stringify({
      user: user,
    }),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/users", postInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function update(user) {
  const patchInfo = {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...header(),
    },

    body: JSON.stringify({
      user: user,
    }),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/users/" + user.id, patchInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        var currentUser = { ...JSON.parse(localStorage.getItem("user")) };

        if (currentUser.id === result.id) {
          currentUser = { token: currentUser.token, ...result };
          localStorage.setItem("user", JSON.stringify(currentUser));
          result.connected = true;
        }

        resolve(result);
      })
      .catch((error) => {
        log(error);
        reject(error);
      });
  });
}

//Retourne l'url pour power bi
function powerBiUrl() {
  return API_DEV + "/users";
}
